<script setup lang="ts">
interface Props {
  image?: {
    url?: string
    alt?: string
    caption?: string
  }
  tags?: {
    name: string
    html_path: string
  }[]
  variant?: 'cover_aside' | 'cover_full_width'
  isLoading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  image: () => ({
    url: undefined,
    alt: undefined,
    caption: undefined,
  }),
  isLoading: false,
  variant: 'cover_aside',
})
</script>

<template>
  <section class="container relative mb-8 mt-6 md:mb-16 md:mt-12">
    <div class="md:space-y-6 lg:space-y-8">
      <div class="mx-auto max-w-screen-lg text-center">
        <div class="space-y-1 md:space-y-4">
          <h1 class="text-2xl font-semibold relative lg:text-4xl xl:text-6xl">
            <slot name="title" />
          </h1>

          <ul
            v-if="props.tags"
            class="flex flex-wrap justify-center xl:text-lg"
          >
            <li
              v-for="tag in props.tags"
              :key="`header_tag_${tag.name}`"
              class="after:mx-2 after:content-['/'] last:after:content-['']"
            >
              <NuxtLink
                :to="tag.html_path"
                class="text-xs font-semibold uppercase text-pink-500 hover:text-pink-700 focus-visible:z-10 focus-visible:rounded focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 lg:text-sm"
              >
                {{ tag.name }}
              </NuxtLink>
            </li>
          </ul>

          <slot
            v-if="$slots.subtitle"
            name="subtitle"
          />
        </div>
      </div>

      <AppHeaderPageCoverImage
        v-if="props.image.url"
        :url="props.image.url"
        :alt="props.image.alt"
        :caption="props.image.caption"
        :variant="props.variant"
      />
    </div>

    <transition name="fade">
      <div
        v-if="props.isLoading"
        class="absolute left-0 right-0 -bottom-16 w-full py-4 text-center"
      >
        <YscLoader class="mx-auto h-8 w-8" />
      </div>
    </transition>
  </section>
</template>
